import communityWalkthrough from '../../modules/community/walkthrough/en-za.json';

export const EN_ZA = {
  translation: {
    ...communityWalkthrough,
  },
};
